import React, { useState } from 'react';
import {
  Button,
  Input,
  InputNumber,
  Space,
  Typography,
  message,
  Card,
  Table,
  Tag,
} from 'antd';
import PageTitle from '../../components/PageTitle';
import { adminPublicPoolVoiceTest, adminPublicPoolVoiceTestCallsToday } from '../../api';

const { Text, Paragraph } = Typography;

const voiceAnswerTagColor = (status) => {
  if (status === 'answered') return 'success';
  if (status === 'send_failed' || status === 'query_error') return 'error';
  if (status === 'unanswered') return 'warning';
  return 'default';
};

const PublicPoolVoiceTest = () => {
  const [phone, setPhone] = useState('');
  const [houseName, setHouseName] = useState('');
  const [roomFang, setRoomFang] = useState('');
  const [amount, setAmount] = useState(10);
  const [sendLoading, setSendLoading] = useState(false);
  const [queryLoading, setQueryLoading] = useState(false);
  const [list, setList] = useState([]);
  const [queryMsg, setQueryMsg] = useState('');

  const loadToday = async (phoneOverride) => {
    const p = String(phoneOverride ?? phone ?? '').trim();
    if (!p) {
      message.warning('请先输入手机号');
      return;
    }
    setQueryLoading(true);
    try {
      const res = await adminPublicPoolVoiceTestCallsToday(p);
      if (res?.success) {
        setList(Array.isArray(res.data?.list) ? res.data.list : []);
        setQueryMsg(res.msg || '');
      } else {
        setList([]);
        message.error(res?.msg || '查询失败');
      }
    } catch (e) {
      setList([]);
      message.error(e.response?.data?.msg || e.message || '查询失败');
    } finally {
      setQueryLoading(false);
    }
  };

  const sendTest = async () => {
    const p = String(phone || '').trim();
    if (!p) {
      message.warning('请输入手机号');
      return;
    }
    setSendLoading(true);
    try {
      const res = await adminPublicPoolVoiceTest({
        phone: p,
        house_name: String(houseName || '').trim(),
        room_fang: String(roomFang || '').trim(),
        amount: amount != null ? amount : 0,
      });
      if (res?.success) {
        message.success(res.msg || '已发起外呼');
        await loadToday(p);
      } else {
        message.error(res?.msg || '外呼失败');
        await loadToday(p);
      }
    } catch (e) {
      message.error(e.response?.data?.msg || e.message || '外呼失败');
    } finally {
      setSendLoading(false);
    }
  };

  return (
    <div>
      <PageTitle title="公共号池语音测试" />

      {/* <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16, maxWidth: 720 }}
        message="独立测试工具（低电量话术）"
        description={
          <>
            填哪个手机号就打哪个，不走白名单、设备订阅和定时任务。
            话术变量：<Text code>fang</Text> = 房产名 + 房间号，<Text code>qian</Text> = 金额（播报时截断小数）。
            请保持 <Text code>voice_notify_called_show_number</Text> 为空以使用公共号池。
          </>
        }
      /> */}

      <Card title="发起测试外呼" size="small" style={{ marginBottom: 16, maxWidth: 720 }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text type="secondary">手机号</Text>
            <Input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="例如 13811111111"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房产名</Text>
            <Input
              value={houseName}
              onChange={(e) => setHouseName(e.target.value)}
              placeholder="请输入房产名"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">房间号</Text>
            <Input
              value={roomFang}
              onChange={(e) => setRoomFang(e.target.value)}
              placeholder="请输入房间号"
              disabled={sendLoading}
            />
          </div>
          <div>
            <Text type="secondary">剩余金额（播报时截断小数）</Text>
            <InputNumber
              min={0}
              step={1}
              style={{ width: '100%' }}
              value={amount}
              onChange={(v) => setAmount(v)}
              placeholder="请输入金额"
              disabled={sendLoading}
            />
          </div>
          <Paragraph type="secondary" style={{ marginBottom: 0, fontSize: 12 }}>
            预览 fang：{[houseName, roomFang].map((s) => String(s || '').trim()).filter(Boolean).join(' ') || '—'}
            {' · '}
            预览 qian：{amount != null ? String(Math.trunc(Number(amount))) : '—'}
          </Paragraph>
          <Space wrap>
            <Button type="primary" loading={sendLoading} onClick={sendTest}>
              发送低电量语音测试
            </Button>
            <Button loading={queryLoading} onClick={() => loadToday()}>
              查询今日结果
            </Button>
          </Space>
        </Space>
      </Card>

      <Card title="今日外呼记录" size="small" style={{ maxWidth: 900 }}>
        {queryMsg ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 12, fontSize: 12 }}>
            {queryMsg}
          </Text>
        ) : null}
        <Table
          size="small"
          rowKey={(row) => String(row.queue_id || row.seq)}
          loading={queryLoading}
          dataSource={list}
          pagination={false}
          locale={{ emptyText: queryLoading ? '查询中…' : '今日暂无测试记录，可先发送或点「查询今日结果」' }}
          columns={[
            { title: '序号', dataIndex: 'seq', width: 56 },
            { title: '时间', dataIndex: 'queued_at', width: 150 },
            { title: '房源', dataIndex: 'fang', ellipsis: true },
            { title: '发送', dataIndex: 'queue_status_text', width: 80 },
            {
              title: '接听结果',
              dataIndex: 'answer_label',
              render: (text, row) => (
                <Tag color={voiceAnswerTagColor(row.answer_status)} style={{ margin: 0 }}>
                  {text || '—'}
                </Tag>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default PublicPoolVoiceTest;
